import type { ReactNode } from 'react';

/**
 * The empty view.
 *
 * Two shapes, and the difference is whether a filter produced the emptiness.
 * **Empty because nothing is waiting** — an empty moderation queue, a report
 * band with no rows yet — states the good state and offers **no** primary
 * action: there is nothing for the operator to do, and a call to action would
 * invent one. **Empty because a filter matched nothing** carries the control
 * that clears the filter.
 *
 * It is never used for a truncation: a list without a traversal control states
 * how many of how many it shows, and that line is not an empty state.
 */
export function EmptyState({ message, action }: { message: string; action?: ReactNode }) {
  return (
    <div className="rounded-md border border-border bg-surface p-6">
      <p className="mb-0 max-w-measure text-sm text-ink-muted">{message}</p>
      {action ? <div className="mt-4 flex flex-wrap gap-3">{action}</div> : null}
    </div>
  );
}
